<img
  src="./assets/images/ccs-glyph-{{ color }}.svg"
  onerror="this.style.display='none'"
  width="52px"
  class="rotate"
  alt="CCS Logo Spinner"
  data-cy="glyph-spinner"
/>
